module.exports = __webpack_public_path__ + "static/media/Italy.fbdd9678.png";